import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Dialog, DialogContent, IconButton, Box } from "@material-ui/core";
import { makeStyles, fade } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

const useStyles = makeStyles((theme) => ({
  sliderBox: {
    height: 300,
    overflow: "hidden",
  },
  subjImgBox: {
    height: 300,
    // overflow: "hidden",
    cursor: "pointer",
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
  subjImg: {
    width: "100%",
    height: "100%",
    display: "block",
    overflow: "hidden",
    objectFit: "contain",
    objectPosition: "center",
    borderRadius: 4,
  },
  slider: {
    marginBottom: theme.spacing(3),
    height: 300,
  },
  dialogBox: {
    "& .MuiDialogContent-root:first-child": {
      paddingTop: 0,
    },
  },
  dialogContent: {
    padding: 0,
    paddingBottom: 60,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dialogImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    color: "#fff",
    zIndex: 1,
  },
  arrow: {
    position: "absolute",
    bottom: 4,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 2,
    color: "#fff",
    backgroundColor: fade(theme.palette.primary.main, 0.4),
  },

  arrowLeft: {
    transform: "translateX(-150%)",
    "& svg": {
      transform: "rotate(180deg)",
    },
  },

  arrowRight: {
    transform: "translateX(50%)",
  },
}));

/** @returns {*}
 * @constructor
 */
const ImageSliderWithDialog = ({ images }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  /** */
  const handleOpen = (i) => {
    setIndex(i);
    setOpen(true);
  };
  /** */
  const handleClose = () => {
    setOpen(false);
  };
  /** */
  const prev = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  /** */
  const next = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  // управление с клавиатуры
  useEffect(() => {
    if (!open) return;
    /** */
    const handleKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
      if (e.key === "Escape") handleClose();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, images.length]);

  const slidesToShow = 5;
  const settings = {
    dots: true,
    infinite: images.length > slidesToShow,
    slidesToShow,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
  };

  return (
    <>
      <Box className={classes.sliderBox}>
        <Slider {...settings} className={classes.slider}>
          {images.map((item, index) => (
            <Box className={classes.subjImgBox} key={item} onClick={() => handleOpen(index)}>
              <img className={classes.subjImg} src={item} alt="logo" />
            </Box>
          ))}
        </Slider>
      </Box>

      <Dialog className={classes.dialogBox} open={open} onClose={handleClose} maxWidth="xl">
        <DialogContent className={classes.dialogContent}>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>

          <IconButton className={`${classes.arrow} ${classes.arrowLeft}`} onClick={prev}>
            <ArrowForwardIosIcon />
          </IconButton>

          <IconButton className={`${classes.arrow} ${classes.arrowRight}`} onClick={next}>
            <ArrowForwardIosIcon />
          </IconButton>

          {images[index] && <img src={images[index]} alt="preview" className={classes.dialogImage} />}
        </DialogContent>
      </Dialog>
    </>
  );
};

ImageSliderWithDialog.defaultProps = {
  images: [],
};

ImageSliderWithDialog.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
};

export default ImageSliderWithDialog;
